import { createUseStyles } from 'react-jss';

const styles = createUseStyles(() => {
  return {
    /* TODO:
      - temporary fix for <Card/> using `href` params, as `wds-react` css is interfering with the Card component's styling
      - <Card/> does not provide a minHeight property at the moment
      - <Card.Body/> does not have a way to remove margins, making cards in a grid look misaligned
    */
    appGrid: {
      '& a': {
        textDecoration: 'none',
        minHeight: '250px',

        '&:hover': {
          textDecoration: 'none',
        },
        '& div[class^="wrenchCardBody-"]': {
          margin: 0,
        },
      },
    },
  };
});

export default styles;
